export const imageCheck = (image) => {
  let namePrefix = image.substr(0, image.indexOf(":"));

  console.log(namePrefix);
  switch (namePrefix) {
    case "PDM":
      return "/wp-content/uploads/Data-Management-NoBG.webp";

    case "CAM":
      return "/wp-content/uploads/Manufacturing.webp";

    case "DRIVEW":
      return "/wp-content/uploads/Mechanical-Design-NoBG.webp";

    case "SWX":
      return "/wp-content/uploads/Mechanical-Design-NoBG.webp";

    case "SIM":
      return "/wp-content/uploads/Simulation.webp";

    case "SWTECH":
      return "/wp-content/uploads/Tech-Comm-NoBG.webp";

    case "ELEC":
      return "/wp-content/uploads/Elecrical-NoBG.webp";

    default:
      return "/wp-content/uploads/Mechanical-Design-NoBG.webp";
  }
};
